import cv from "../assets/pdf/Hasan_CV_Dec_22.pdf";

const pdfs = { cv };

export default pdfs;
